var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 22C45.3137 22 48 19.3137 48 16C48 12.6863 45.3137 10 42 10C38.6863 10 36 12.6863 36 16C36 19.3137 38.6863 22 42 22Z",
    stroke: "#613ED2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C21.3137 36 24 33.3137 24 30C24 26.6863 21.3137 24 18 24C14.6863 24 12 26.6863 12 30C12 33.3137 14.6863 36 18 36Z",
    stroke: "#613ED2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 50C45.3137 50 48 47.3137 48 44C48 40.6863 45.3137 38 42 38C38.6863 38 36 40.6863 36 44C36 47.3137 38.6863 50 42 50Z",
    stroke: "#613ED2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1797 33.0234L36.8397 40.9834",
    stroke: "#613ED2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8197 19.0234L23.1797 26.9834",
    stroke: "#613ED2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBlue);
export default __webpack_public_path__ + "static/media/shareBlue.ffff27015d31aa5e493d674530434c9f.svg";
export { ForwardRef as ReactComponent };